/*
 * @Description: 
 * @Author: shayne
 * @Date: 2021-12-31 15:39:19
 * @LastEditors: shayne
 * @LastEditTime: 2021-12-31 15:45:23
 * @FilePath: /datascreen/src/libs/px2rem.js
 */
!function (n, e) {
  var t = n.documentElement,
    i = "orientationchange" in window ? "orientationchange" : "resize",
    d = function () {
      var n = t.clientWidth;
      if (n) {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        var e = 100 * (n / 1920);
        if (!flag && e <= (8200 / 192)) {
          t.style.fontSize = (8200 / 192) + "px"
          return
        }
        e > 200 && (e = 200), t.style.fontSize = e + "px"
      }
    };
  n.addEventListener && (e.addEventListener(i, d, !1), n.addEventListener("DOMContentLoaded", d, !1))
}(document, window);
